export default __webpack_public_path__ + "static/23_33-d7bd9de9b096452f85a2d6cfc63b6528.png";